<template>
  <v-container>
    <v-card class="d-flex justify-start align-center">
      <v-card width="380px" elevation="0" outlined tile>
        <v-chip class="ml-2 mt-0 mb-0" color="primary">План</v-chip>
      </v-card>
      <v-card class="pl-3 pr-3" outlined tile width="100%">
        <v-text-field
          label="План"
          hint="Объём планового выпуска, в тоннах"
          persistent-hint
          v-model="PLAN_VOLUME"
        ></v-text-field>
      </v-card>
    </v-card>
    <v-card class="d-flex justify-start align-center">
      <v-card width="380px" elevation="0" outlined tile>
        <v-chip class="ml-2 mt-0 mb-0" color="primary">План на период</v-chip>
      </v-card>
      <v-card class="pl-3 pr-3" outlined tile width="100%">
        <v-row no-gutters dense>
          <v-col cols="3" class="mr-3"><v-select :items="periodSet" label="Выберите период" v-model="PLAN_PERIOD_TYPE"/></v-col>
          <v-col cols="3" class="mr-3"><sys-date-panel :header="false" v-model="PLAN_PERIOD"/></v-col>
          <v-col cols="3"><v-text-field label="Год" :value="extractDatePart(PLAN_PERIOD, '-', 0)" readonly/></v-col>
        </v-row>
      </v-card>
    </v-card>
    <v-card class="d-flex justify-start align-center">
      <v-card width="380px" elevation="0" outlined tile>
        <v-chip class="ma-2" color="primary">Коэффициент запаса, %</v-chip>
      </v-card>
      <v-card class="pl-3 pr-3" outlined tile width="100%">
        <v-text-field
          label="Коэффициент запаса"
          hint="Коэффициент запаса, шаг 0.1%"
          persistent-hint
          v-model="STOCK_RATIO"
          type="Number"
          step="0.1"
        ></v-text-field>
      </v-card>
    </v-card>
    <v-card class="d-flex justify-start align-center">
      <v-card width="380px" elevation="0" outlined tile>
        <v-chip class="ml-2 mt-0 mb-0" color="primary">Сезон</v-chip>
      </v-card>
      <v-card class="pl-3 pr-3" outlined tile width="100%">
        <v-radio-group v-model="SEASON_TYPE" row>
          <v-radio
            label="Лето"
            value="1"
          ></v-radio>
          <v-radio
            label="Зима"
            value="2"
          ></v-radio>
        </v-radio-group>
      </v-card>
    </v-card>
    <rcpt-comp-mass-card :components="COMPONENTS" />
  </v-container>
</template>

<script>
import SysDatePanel from '@/components/common/ui/panels/sysDatePanel.vue'
import { dtUtilsMixin } from '@/components/modules/mixins/datetimeUtils'
import RcptCompMassCard from './rcptCompMassCard.vue'
export default {
  name: 'rcptResourcesCard',
  mixins: [dtUtilsMixin],
  props: {
    receipt: {
      type: Object,
      default: function () {
        return {}
      }
    },
    comps: {
      type: Array,
      default: function () {
        return []
      }
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  emits: ['onChange'],
  components: { RcptCompMassCard, SysDatePanel },
  data () {
    return {
      localFT: null,
      localGOST: null,
      periodSet: [
        { text: 'сутки', value: 1 },
        { text: 'месяц', value: 2 },
        { text: 'квартал', value: 3 },
        { text: 'год', value: 4 }
      ]
    }
  },
  computed: {
    PLAN_VOLUME: {
      get: function () {
        return this.receipt.PLAN_VOLUME
      },
      set: function (val) {
        this.onChangeReceipt({ PLAN_VOLUME: val })
      }
    },
    STOCK_RATIO: {
      get: function () {
        return this.receipt.STOCK_RATIO
      },
      set: function (val) {
        this.onChangeReceipt({ STOCK_RATIO: val })
      }
    },
    PLAN_PERIOD: {
      get: function () {
        return this.receipt.PLAN_PERIOD
      },
      set: function (val) {
        console.log('PLAN_PERIOD changed to ', val)
        this.onChangeReceipt({ PLAN_PERIOD: val })
      }
    },
    PLAN_PERIOD_TYPE: {
      get: function () {
        return this.receipt.PLAN_PERIOD_TYPE
      },
      set: function (val) {
        this.onChangeReceipt({ PLAN_PERIOD_TYPE: val })
      }
    },
    SEASON_TYPE: {
      get: function () {
        return this.receipt.SEASON_TYPE
      },
      set: function (val) {
        this.onChangeReceipt({ SEASON_TYPE: val })
      }
    },
    COMPONENTS: {
      get () {
        return this.receipt.COMPONENTS
      }
    }
  },
  watch: {
    activeTab (val) {
      console.log('rcptResourcesCard activeTab changed to ', val)
    }
  },
  methods: {
    onChangeReceipt (val) {
      this.$emit('onChange', val)
    }
  },
  mounted () {
    console.log('rcptResourcesCard mounted with project ', this.receipt)
  }
}
</script>
